import { buildType } from "@helpers/expo-extras";
import { isWeb } from "@helpers/platform";
import { useAppStore } from "@hooks/useAppStore";
import * as SentryReact from "@sentry/react";
import * as SentryNative from "@sentry/react-native";

const isDev = process.env.NODE_ENV === "development";
export const reactNavigationIntegration =
	SentryNative.reactNavigationIntegration();

export const getSentryInstance = () => {
	if (isWeb) {
		return SentryReact;
	}
	return SentryNative;
};

const ALLOWED_NETWORK_URLS = [
	"https://prod.api.memorang.io/assessments/v1/responses/answer-events",
];

export const initSentry = () => {
	const currentAppVersion = useAppStore.getState().app?.version;
	const dsn = process.env.EXPO_PUBLIC_SENTRY_DSN;
	if (isWeb) {
		if (!SentryReact.isInitialized()) {
			SentryReact.init({
				dsn,
				enabled: !isDev,
				// debug: isDev,
				environment: process.env.NODE_ENV,
				tracesSampleRate: 1.0,
				profilesSampleRate: 0.5,
				replaysSessionSampleRate: 0,
				replaysOnErrorSampleRate: isDev ? 0 : 1,
				integrations: [
					SentryReact.replayIntegration({
						maskAllText: false,
						maskAllInputs: true,
						blockAllMedia: true,
						block: [".paywall", ".checkout", "[data-private]"],
						mask: ["[data-pii]"],
						networkDetailAllowUrls: ALLOWED_NETWORK_URLS,
						networkRequestHeaders: ["X-Custom-Header"],
						networkResponseHeaders: ["X-Custom-Header"],
						maxReplayDuration: 1000 * 600, // 10 minutes
					}),
					SentryReact.browserTracingIntegration(),
				],
			});
			SentryReact.setTag("app", buildType);
			SentryReact.setTag("version", currentAppVersion);
		}
	} else {
		SentryNative.init({
			dsn,
			enabled: !isDev,
			// debug: isDev,
			environment: process.env.NODE_ENV,
			tracesSampleRate: 1.0,
			profilesSampleRate: 1.0,
			integrations: [reactNavigationIntegration],
		});
		SentryNative.setTag("app", buildType);
		SentryNative.setTag("version", currentAppVersion);
	}
};

export const replayManager = () => {
	const replay = SentryReact.getReplay();

	return {
		startReplay: () => {
			if (replay && isWeb) {
				try {
					replay.start();
				} catch (error) {
					console.error("Failed to start replay:", error);
				}
			}
		},
		stopReplay: () => {
			if (replay && isWeb) {
				try {
					replay.stop();
				} catch (error) {
					console.error("Failed to stop replay:", error);
				}
			}
		},
	};
};
